__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-passkey-auth-root'].baseUrl;
import ModuleContainer from './components/main';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}